export interface PositionalParams {
  left?: number;
  top?: number;
}

export interface CornerPoint {
  x: number;
  y: number;
}

export const CORNER_PADDING = 5;
export const POPUP_WIDTH = 278;
export const BUTTON_TOP_THRESHOLD = 65;

/** One DEFAULT_2 row (thumbnail + text + sub-text) plus the container's vertical padding. */
const POPUP_ROW_HEIGHT = 72;
const POPUP_VERTICAL_PADDING = 16;

/** The popup grows with its option count, so the on-canvas clamp has to measure it the same way. */
export const getPopupHeight = (optionCount: number): number => {
  return optionCount * POPUP_ROW_HEIGHT + POPUP_VERTICAL_PADDING;
};
